import { useState } from "react";
// import axios from "../../axios";
// import { deploymentTypes, servers, serverType } from "../../deployment-config";
import PopupWrapper from "../../components/PopupWrapper";
// import { useForm } from "react-hook-form";
// import { FloatLabelInput, LoadingButton } from "../../Utils/CustomComponent";
import ResetPassword from "./ResetPassword";
import { useNavigate } from "react-router-dom";
// let server_address =
//   serverType === deploymentTypes.development
//     ? servers.development
//     : servers.production;
// const environment_hostname = "http://" + server_address + "/api/v1";

const ForgotPasswordModal = () => {
  const [viewAll, setViewAll] = useState(false);
  const navigate = useNavigate();

  function goToResetPage() {
    navigate("/reset-password");
    // setViewAll(true);
  }

  return (
    <>
      <button
        type="button"
        value={"Forgot password?"}
        className="btn w-100 linkClick text-decoration-underline text-end p-0"
        data-bs-toggle="modal"
        data-bs-target="#forgotPasswordModal"
        // onClick={() => setViewAll(true)}
        onClick={() => goToResetPage()}
      >
        Forgot password?
      </button>
      <PopupWrapper
        Component={<ResetPassword closeModal={() => setViewAll(false)} />}
        toShow={viewAll}
        closeEventHandler={() => {
          setViewAll(false);
        }}
        title="Password reset"
      />
    </>
  );
};

export default ForgotPasswordModal;
